<template>
  <form @submit.prevent="submitForm()">
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-user-tie" /></div>
        <input
          type="text"
          name="username"
          ref="loginusername"
          v-model="form.username"
          class="form-control"
          :class="{ 'form-control-sm': position == 'aside', 'is-invalid': errors.form.username.length }"
          placeholder="Имя пользователя" />
        <div v-if="errors.form.username.length" class="invalid-feedback">{{ errors.form.username }}</div>
      </div>
    </div>

    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-key" /></div>
        <input
          type="password"
          name="password"
          v-model="form.password"
          class="form-control"
          :class="{ 'form-control-sm': position == 'aside', 'is-invalid': errors.form.password.length }"
          placeholder="Пароль" />
        <div v-if="errors.form.password.length" class="invalid-feedback">{{ errors.form.password }}</div>
      </div>
    </div>

    <div data-error v-if="errors.form.common.length" class="alert alert-warning my-1 px-2 py-1" role="alert">
      {{ errors.form.common }}
    </div>

    <div class="mt-2 mb-1 d-flex justify-content-between">
      <div>
        <a :href="links.profile.lostpassword" class="link-left" :class="{ 'link-left_small': position == 'aside' }"
          >Забыли пароль?</a
        ><br />
        <a :href="links.profile.help" class="link-left" :class="{ 'link-left_small': position == 'aside' }">Помощь</a>
      </div>

      <div>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="isLoading"
          :class="{ 'btn-sm': position == 'aside' }"
          title="Войти на сайт">
          <font-awesome-icon icon="fa-solid fa-user" /> Войти
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUserTie, faUser, faKey } from '@fortawesome/free-solid-svg-icons';
library.add(faUserTie, faUser, faKey);

export default {
  data: function () {
    return {
      form: {
        _token: this.csrf,
        username: '',
        password: '',
      },
      errors: {
        form: {
          username: '',
          password: '',
          common: '',
        },
      },
      isLoading: false,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      let isError = false;

      if (this.form.username.length == 0) {
        this.errors.form.username = 'Нужно ввести ID клиента.';
        isError = true;
      }

      if (this.form.password.length == 0) {
        this.errors.form.password = 'Нужно ввести пароль.';
        isError = true;
      }

      if (isError) {
        return false;
      }

      this.isLoading = true;

      axios
        .post(`/evocms-user/auth`, this.form)
        .then((res) => {
          if (res.data.status === 'ok') {
            // res.data.message // "Успешная авторизация."
            // res.data.redirect // "https://dev1.smtauto.ru/profile"
            // res.data.status // 'ok'

            this.form.username = '';
            this.form.password = '';
            this.errors.form.common = res.data.message;

            // similar behavior as an HTTP redirect
            // window.location.replace("http://stackoverflow.com");
            // similar behavior as clicking on a link
            // window.location.href = "http://stackoverflow.com";

            // if (res.data.redirect !== '') {
            // window.location.replace(res.data.redirect);
            // }

            window.location.reload();
          }
          if (res.data.status === 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.$refs.loginusername.focus();
  },
};
</script>
